// extracted by mini-css-extract-plugin
export var cardHeader = "_t4-0";
export var reorderHandle = "_t4-3";
export var titleArea = "_t4-1";
export var titleAreaWithHandle = "_t4-2";